<template>
	<div class="login_view_box">
		<div class="login_form_box">
			<div class="header_box">
				<!-- <img :src="getLogoConfig.logoImg" alt="" style="width:120px;vertical-align:middle">
			<h1>{{ getPlatformName.title }}</h1> -->
				<img :src="defaultTitle" alt="" style="" />
			</div>
			<div class="login_box flex-cen">
				<div class="form_box">
					<div class="header_tab_box m-b-20">
						<!-- <div v-for="(item, index) in tabList" :key="index" :class="{ active: active === index }" class="title" @click="changeActive(index)">
							{{ item }}
						</div> -->
						{{ $t('Login.PleaseLogin') }}
					</div>

					<transition name="el-zoom-in-center">
						<div class="isLogin_username" v-if="active === 0">
							<div class="login_input_box flex-cen" style="height: 60px">
								<el-input :placeholder="$t('Login.PleaseEnterUserAccount')" v-model="userName" @keyup.enter.native="getLogin">
									<i slot="prefix" class="el-input__icon el-icon-user"></i>
								</el-input>
							</div>
							<div class="login_input_box">
								<el-input type="password" :placeholder="$t('Login.PleaseEnterYourPassword')" v-model="passWord" show-password @keyup.enter.native="getLogin">
									<i slot="prefix" class="el-input__icon el-icon-lock"></i>
								</el-input>

								<!-- <div class="login_autoInput_box flex-be m-t-5">
									<el-checkbox v-model="autoLogin">下次自动登录</el-checkbox>
									<span @click="forgotPasswordDialogTag = true">忘记密码？</span>
								</div> -->
							</div>
							<div class="login_input_box flex-cen">
								<el-input :placeholder="$t('Login.CheckCode')" style="margin-right: 15px" size="large" v-model="loginFormcode" @keyup.enter.native="getLogin">
									<i slot="prefix" class="el-input__icon el-icon-wallet"></i>
								</el-input>
								<img :src="codeUrl" @click="getClientFunc" class="login-code-img" />
							</div>
							<div class="submit_btn_box">
								<el-button type="primary" style="width: 100%" @click="getLogin()">{{ $t('Login.Login') }}</el-button>
								<div>
									<div class="register m-t-10" style="display: block" @click="toRegisterFn()">{{ $t('Login.NewUserRegistration') }}</div>
									<div class="login_autoInput_box flex-be m-t-5" style="color: #005dbf; display: block; text-align: end">
										<span @click="forgotPasswordDialogTag = true">{{ $t('Login.ForgottenPassword') }}/</span>
										<span @click="forgotPasswordDialogTag = true">{{ $t('Login.ResetPassword') }}</span>
									</div>
								</div>
							</div>
						</div>
					</transition>

					<transition name="el-zoom-in-center">
						<div class="isLogin_username" v-if="active === 1">
							<div class="login_input_box flex-cen">
								<el-input placeholder="请输入手机号码" v-model="phone">
									<i slot="prefix" class="el-input__icon el-icon-user"></i>
								</el-input>
							</div>

							<div class="login_input_box">
								<div class="verification_code flex-be">
									<el-input class="m-r-5" placeholder="请输入验证码" v-model="code">
										<i slot="prefix" class="el-input__icon"></i>
									</el-input>
									<smsSend :mobile="phone" :sms-type="'VALID_LOGIN'"></smsSend>
								</div>
								<div class="login_autoInput_box flex-be m-t-5">
									<el-checkbox v-model="autoLogin">下次自动登录</el-checkbox>
									<span @click="forgotPasswordDialogTag = true">{{ $t(Login.ForgottenPassword) }}？</span>
								</div>
							</div>

							<div class="submit_btn_box">
								<el-button type="primary" style="width: 100%" @click="getLoginForPhone()">{{ $t(Login.Login) }}</el-button>
								<div class="register m-t-10" @click="toRegisterFn()">{{ $t(Login.NewUserRegistration) }}</div>
							</div>
						</div>
					</transition>
				</div>
			</div>
			<!-- <div class="footer_box flex-cen">
			<div class="footer_view_box">
				<div class="footer_serve_box m-b-10">
					<span>帮助</span>
					<span>隐私</span>
					<span>条款</span>
				</div>
				<div>opyright © 2020  版权所有 | 京ICP备08011069号 | 京公网安备 XXXXXXXXX号</div>
			</div>
		</div> -->
		</div>

		<!--  忘记密码  -->
		<el-dialog :title="$t('Login.ForgottenPassword')" :visible.sync="forgotPasswordDialogTag" :close-on-click-modal="false" width="600px" v-dialogDrag>
			<forgotPassword v-if="forgotPasswordDialogTag" :address="address" :smsType="'FORGET_PWD'" @forgotPasswordSuccess="closeForgetPass"></forgotPassword>
		</el-dialog>
	</div>
</template>

<script>
import Cookie from '@/utils/cookie'
import crypto from '@/utils/Crypto'
import smsSend from '@/components/SmsSend'
import forgotPassword from '@/components/DialogComponent/forgotPassword'

import { mapGetters } from 'vuex'

export default {
	name: 'login',
	components: {
		smsSend,
		forgotPassword
	},
	data() {
		return {
			defaultTitle: require('@/assets/imgs/newHome/位图.png'),
			active: 0,
			tabList: ['账户密码登录'], //, '手机号登录'
			userName: '',
			passWord: '',
			phone: '',
			code: '',
			autoLogin: true,
			// 忘记密码弹窗
			forgotPasswordDialogTag: false,
			address: '',
			codeUrl: '',
			uuid: '',
			loginFormcode: ''
		}
	},
	created() {
		// this.address = this.$const.userInfo.forgetUpdatePwd
		this.address = this.$const.common.resetPassword
	},
	computed: {
		...mapGetters(['getLogoConfig', 'getPlatformName'])
	},
	mounted() {
		this.getClientFunc()
	},
	// 方法集合
	methods: {
		closeForgetPass() {
			this.forgotPasswordDialogTag = false
		},
		changeActive(ind) {
			if (this.active === ind || this.active === null) return
			this.active = null
			setTimeout(() => {
				this.active = ind
			}, 300)
		},
		toRegisterFn() {
			this.$router.push('register')
		},
		async getClientFunc() {
			let params = {}
			try {
				let res = await this.$http.get(this.$const.common.getClient, params)
				if (res && res.code == 200) {
					this.codeUrl = 'data:image/gif;base64,' + res.img
					this.uuid = res.uuid
					console.log('---', this.$route.query.redirect)
				}
			} catch (error) {
				console.log(error)
			}
		},
		/*
		 * @name: 登录
		 * @time: 2022-09-16 15:00:23
		 */
		async getLogin() {
			let params = {
				username: this.userName,
				password: this.passWord,
				uuid: this.uuid,
				code: this.loginFormcode
			}
			if (!this.userName || !this.passWord) {
				this.$message.warning(this.$PubText.loginTips)
				return
			}
			try {
				let resCheck = await this.$http.post(this.$const.common.checkPassword, params)
				console.log(resCheck)
				let res = await this.$http.post(this.$const.common.getlogin, params)
				if (res && res.code == 200 && res.token) {
					await this.$store.dispatch('user/updateuserInfo', {
						username: this.userName
					})
					console.log('---', this.$route.query.redirect)
					await this.$message.success(this.$PubText.loginSuccess)
					await Cookie.set('PIE_MALL_Token', res.token)
					await this.$store.dispatch('user/getUserINFO', {})
					// await this.$store.dispatch("shoppingCart/getCartINFO", {})
					await this.$router.push(this.$route.query.redirect || '/')
				} else {
					this.$message.warning('用户账号或密码不正确！')
				}
			} catch (error) {
				console.log(error)
			}
		},
		/*
		 * @name: 手机号登录
		 * @time: 2022-10-20 15:00:23
		 */
		async getLoginForPhone() {
			let params = {
				code: this.code,
				phoneNumber: this.phone
			}
			if (!this.code || !this.phone) {
				this.$message.warning(this.$PubText.loginForPhoneTips)
				return
			}
			try {
				let res = await this.$http.post(this.$const.userInfo.LoginForPhone, params)
				if (res && res.data) {
					// await this.$store.dispatch("user/updateuserInfo", {
					//   username: this.userName
					// });

					await this.$message.success(this.$PubText.loginSuccess)
					await Cookie.set('PIE_MALL_Token', res.data.accessToken)
					await this.$store.dispatch('user/getUserINFO', {})
					await this.$store.dispatch('shoppingCart/getCartINFO', {})
					await this.$router.push(this.$route.query.redirect || '/')
				}
			} catch (error) {
				console.log(error)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.login_view_box {
	min-width: 1200px;
	width: 100%;
	height: 100vh;
	min-height: 800px;
	background: url('../../assets/imgs/login/moonBG.jpg');
	background-size: 100% 100%;

	.login_form_box {
		width: 100%;
		height: 100%;

		.header_box {
			display: flex;
			align-items: center;
			height: 15%;
			padding-left: 5vw;

			// img {
			// 	width: 60px;
			// 	// margin-right: 10px;
			// }

			h1 {
				font-size: 40px;
				color: #ffffff;
				font-weight: 400;
			}
		}

		.login_box {
			height: 75%;
			padding: 80px 0;
			box-sizing: border-box;

			.form_box {
				width: 500px;
				min-height: 400px;
				max-height: 100%;
				background: rgba(255, 255, 255, 0.7);
				border-radius: 8px;
				padding: 35px;
				box-sizing: border-box;

				.header_tab_box {
					width: 100%;
					height: 30px;
					display: flex;
					position: relative;

					.title {
						display: flex;
						align-items: center;
						// justify-content: center;
						width: 50%;
						font-size: 20px;
						cursor: pointer;
						user-select: none;
					}

					.active {
						&::after {
							content: '';
							display: block;
							width: 30%;
							height: 3px;
							background: #0e81e5;
							position: absolute;
							bottom: -5px;
						}
					}
				}

				.login_input_box {
					height: 50px;

					/deep/ .el-input__inner {
						background-color: rgba(255, 255, 255, 0.7);
						border: 1px solid #409eff;

						&:hover {
							border-color: #409eff;
						}

						&::placeholder {
							color: #5c5c5c;
						}
					}

					/deep/ .el-input__prefix,
					.el-input__suffix {
						top: 2px;
					}

					/deep/ .el-input__icon {
						color: #5c5c5c;
					}

					.verification_code {
						width: 100%;
						height: 40px;
					}

					.login_autoInput_box {
						span {
							cursor: pointer;
						}
					}
				}

				.submit_btn_box {
					width: 100%;
					height: 60px;
					text-align: center;

					.register {
						font-size: 14px;
						cursor: pointer;
					}
				}
			}
		}

		.register_box {
			height: 75%;
			padding: 20px 0;
			box-sizing: border-box;
		}

		.footer_box {
			min-width: 1200px;
			width: 100%;
			height: 10%;
			flex-direction: column;

			.footer_view_box {
				width: 600px;
				color: #fff;
				text-align: center;
				cursor: pointer;

				.footer_serve_box {
					display: flex;
					align-items: center;
					justify-content: space-around;
				}
			}
		}
	}
}
.login-code-img {
	height: 40px;
}
</style>
